import { useHistory } from "react-router";
import { useNamedRoutes } from "../NamedRoutes";
import { useIsMobile } from "../Responsive";
import { useEffect } from "react";

type Props = {
    swiperInputRef: React.RefObject<HTMLIonInputElement>,
    slideToRef: React.MutableRefObject<number>,
    page?: number;
    link: string;
};

export const SwiperRedirectPageOneListener: React.FC<Props> = ({
    link,
    page,
    swiperInputRef,
    slideToRef
}) =>
{
    const { generate } = useNamedRoutes();
    const history = useHistory();


    const mobileView = useIsMobile();

    useEffect(() =>
    {
        if (!mobileView) return;

        const unlisten = history.listen((location, action) =>
        {
            const eventRoute = generate(link, { page: `${page || 0}` });
            const isSameRoute = location.pathname === eventRoute;

            if (action === 'PUSH' && !isSameRoute) {
                slideToRef.current = 0;
                swiperInputRef.current?.click();
            }
        });

        return () =>
        {
            unlisten();
        };
    }, [generate, history, link, mobileView, page, slideToRef, swiperInputRef]);

    return <></>;
};
